import './HscPipelineFees.scss';
import Component from './HscPipelineFees.js';
export default Component;